import { render } from "./prices.vue?vue&type=template&id=c747a69a&scoped=true"
import script from "./prices.vue?vue&type=script&lang=js"
export * from "./prices.vue?vue&type=script&lang=js"

import "./prices.vue?vue&type=style&index=0&id=c747a69a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c747a69a"]])

export default __exports__